import React from 'react';
import PropTypes from 'prop-types';
import DateFilter from '../common/dateFilter';
import Autocomplete from '../common/autocomplete';
import MultipleTagsInput from '../common/inputs/multipleTagsInput';
import strings from '../locales/';

const validateDate = (filter, date) => {
  let dateValue;
  if (filter) {
    dateValue = filter;
  } else if (date) {
    dateValue = date.substring(0, 10);
  } else {
    dateValue = new Date();
  }
  return dateValue;
};

const Header = props => !props.loadingFilter ? (
  <div className="header">
    <MultipleTagsInput
      categories={props.filter}
      filteredTags={props.filters.tags}
      language={props.language.filter}
      handleSubmit={props.handleSubmit}
      isMultiple={true}
    />
    <div className="box-form islabel box170">
      <div>
        <label>{props.language.filter.driver}</label>
      </div>
      <div>
        <Autocomplete
          value={props.filters.driver ? props.filters.driver.alias : strings.all}
          save={strings.all}
          id={`driver`}
          alias="alias"
          select="id"
          idItem="id"
          filter={props.drivers ? props.drivers : []}
          handleSubmit={props.handleSubmit}
        />
      </div>
    </div>
    <div className="box-form islabel box170">
      <div>
        <label htmlFor="date-start">{props.language.filter.from}</label>
      </div>
      <div>
        <DateFilter
          date={validateDate(props.filters.date.fechaStartFinal, props.date.response.maxDate)}
          dif={props.filters.date.fechaStartFinal ? 0 : -((props.defaultRangeInDay-1)*24*60*60*1000)}
          id="date-start"
          handleSubmit={props.handleSubmit}
        />
      </div>
    </div>
    <div className="box-form islabel box170">
      <div>
        <label htmlFor="date-end">{props.language.filter.to}</label>
      </div>
      <div>
        <DateFilter
          date={validateDate(props.filters.date.fechaEndFinal, props.date.response.maxDate)}
          dif={0}
          id="date-end"
          handleSubmit={props.handleSubmit}
        />
      </div>
    </div>
  </div>
): (
  <div className="header" />
);

Header.propTypes = {
  filter: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.object]).isRequired,
  language: PropTypes.oneOfType([PropTypes.object]).isRequired,
  date: PropTypes.oneOfType([PropTypes.object]).isRequired
};

export default Header;



// WEBPACK FOOTER //
// ./source/client/components/driver_behavior/header.jsx